export default __webpack_public_path__ + "static/media/third.c446380d.jpg";